import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const Announcement = lazyRouteComponent(() => import('../pages/announcements'))

export const announcementsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'announcements',
  component: Announcement,
})
